// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"d1029de856048b09761e","339":"520782bf6846ea730530"}[chunkId] + ".js";
};